import styled from 'styled-components';

export const StyledCtaButton = styled.div``;
